import { c as _c } from "react/compiler-runtime";
import { SocialIcon } from 'react-social-icons';
type PropsType = {
  links: string[];
  className?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
};
const sizeMap = {
  xs: 20,
  sm: 25,
  md: 30,
  lg: 35,
  xl: 40
};
const SocialMediaLinks = t0 => {
  const $ = _c(8);
  const {
    links,
    className,
    size: t1
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const iconSize = sizeMap[size];
  const t2 = `flex flex-row items-center justify-center space-x-1 ${className || ""}`;
  let t3;
  if ($[0] !== iconSize || $[1] !== links) {
    let t4;
    if ($[3] !== iconSize) {
      t4 = (link, key) => <SocialIcon key={key} url={link} target="_blank" rel="noopener noreferrer" style={{
        height: iconSize,
        width: iconSize
      }} className="opacity-80 transition-all duration-300 hover:opacity-100" />;
      $[3] = iconSize;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    t3 = links.map(t4);
    $[0] = iconSize;
    $[1] = links;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default SocialMediaLinks;